<div class="key-buttons">
  <a (click)="shareToFacebook()" href="javascript:" class="btn btn-facebook">
    <i class="icofont icofont-social-facebook"></i>
    Facebook
  </a>

  <a [href]="twitterShareURL" target="_blank" class="btn btn-twitter">
    <i class="icofont icofont-social-twitter"></i>
    Twitter
  </a>

  <a [href]="whatsAppShareURL" target="_blank" class="btn btn-success">
    <i class="icofont icofont-brand-whatsapp"></i>
    WhatsApp
  </a>
</div>
